// DeviceID -> human label + which control screen to use. Mirrors the Flutter
// screenRedirector() mapping (docs/03-devices.md).

export const ONE_TOUCH_IDS = [5, 6, 21, 22, 28, 31, 33, 40, 42, 55, 59, 60, 80];

export function deviceTypeKey(deviceId) {
  const id = Number(deviceId);
  if (id === 49) return 'fourTouch';
  if (id === 56) return 'twoTouch';
  if (id === 53) return 'fan';
  if (id === 51) return 'curtain';
  if (id === 24) return 'rgb';
  if (id === 25) return 'wwh';
  if (id === 23) return 'wwrgb';
  if (id === 3) return 'door';
  if (id === 82) return 'singlePhase';
  if (id === 16) return 'threePhase';
  if (ONE_TOUCH_IDS.includes(id)) return 'oneTouch';
  return 'unsupported';
}

// Grid column span per device. The 5-channel WWRGB light is wider so all its
// sliders fit; everything else uses the dense default.
export function deviceGridSpan(deviceId) {
  const k = deviceTypeKey(deviceId);
  if (k === 'wwrgb') return { xs: 12, sm: 6, md: 6, lg: 4 };
  if (k === 'singlePhase' || k === 'threePhase') return { xs: 12, sm: 6, md: 6, lg: 4 };
  return { xs: 6, sm: 4, md: 3, lg: 2 };
}

export function deviceLabel(deviceId) {
  switch (deviceTypeKey(deviceId)) {
    case 'fourTouch': return '4-Gang Switch';
    case 'twoTouch': return '2-Gang Switch';
    case 'oneTouch': return 'Switch';
    case 'fan': return 'Fan';
    case 'curtain': return 'Curtain';
    case 'rgb': return 'RGB Light';
    case 'wwh': return 'White Light';
    case 'wwrgb': return 'WWRGB Light';
    case 'door': return 'Door Lock';
    case 'singlePhase': return 'Energy Meter';
    case 'threePhase': return '3-Phase Meter';
    default: return 'Device';
  }
}
